import styled from 'styled-components';

const Version = styled('span')`
  color: white;
`;

const VersionCmp = () => {

  const version = process.env.REACT_APP_VERSION;
  const deployment = process.env.REACT_APP_DEPLOYMENT;
  const env = process.env.REACT_APP_NODE_ENV;

  let appInfo = `${version}`;
  appInfo += deployment ? `-${deployment}` : '';
  appInfo += env ? `-${env}` : '';

  return (
    <Version>version: {appInfo}</Version>
  );
}

export default VersionCmp;
